import request from "@/router/axios";

//page-loan-information
export const pageLoanInformationList = (current, size, params) => {
  return request({
    url: "/api/blade-loanAfterInformation/loanAfterInformation/page-loan-information",
    method: "get",
    params: {
      ...params,
      current,
      size,
    },
  });
};

//page-action
export const pageActionList = (current, size, params) => {
  return request({
    url: "/api/blade-loanAfterInformation/loanAfterInformation/page-action",
    method: "get",
    params: {
      ...params,
      current,
      size,
    },
  });
};

//submitAction
export const submitAction = (row) => {
  return request({
    url: "/api/blade-loanAfterInformation/loanAfterInformation/submit-action",
    method: "post",
    data: row,
  });
};

//page-bad-assets
export const pageBadAssetsList = (current, size, params) => {
  return request({
    url: "/api/blade-loanAfterInformation/loanAfterInformation/page-bad-assets",
    method: "get",
    params: {
      ...params,
      current,
      size,
    },
  });
};

//submitBadAssets
export const submitBadAssets = (row) => {
  return request({
    url: "/api/blade-loanAfterInformation/loanAfterInformation/submit-bad-assets",
    method: "post",
    data: row,
  });
};

//page-law
export const pageLawList = (current, size, params) => {
  return request({
    url: "/api/blade-loanAfterInformation/loanAfterInformation/page-law",
    method: "get",
    params: {
      ...params,
      current,
      size,
    },
  });
};

//submitLaw
export const submitLaw = (row) => {
  return request({
    url: "/api/blade-loanAfterInformation/loanAfterInformation/submit-law",
    method: "post",
    data: row,
  });
};
